module.exports = __webpack_public_path__ + "img/Path_806.44479134.svg";